/**
 * @generated SignedSource<<afd9cfcc65d5f673737b73fc85ba6f29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderUserFragment$data = {
  readonly id: number | null | undefined;
  readonly name: string | null | undefined;
  readonly username: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
  readonly " $fragmentType": "HeaderUserFragment";
};
export type HeaderUserFragment$key = {
  readonly " $data"?: HeaderUserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderUserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderUserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c8e39a0438400e7595eb023d2e5a2c59";

export default node;
